import Ajv2020, { type ErrorObject } from "ajv/dist/2020.js";
import schema from "./content.schema.json";
import type { LandingContent, SiteId } from "./types";

type CatalogEntry = { siteId: SiteId; lpContentFile: string; lpContent: unknown };
const validate = new Ajv2020({ allErrors: true, strict: true }).compile(schema);

export function validateLandingContentCatalog(
	catalog: readonly CatalogEntry[],
): asserts catalog is readonly (CatalogEntry & { lpContent: LandingContent })[] {
	const expectedFiles = new Set(catalog.map(({ siteId }) => `${siteId}.json`));
	for (const entry of catalog) {
		if (!expectedFiles.has(entry.lpContentFile)) {
			throw new Error(`LP content catalog references missing JSON: ${entry.lpContentFile}`);
		}
		if (!validate(entry.lpContent)) {
			const detail = (validate.errors ?? [])
				.map((error: ErrorObject) => `${error.instancePath || "/"} ${error.message}`)
				.join(", ");
			throw new Error(`${entry.lpContentFile}: ${detail}`);
		}
		if ((entry.lpContent as LandingContent).siteId !== entry.siteId) {
			throw new Error(`${entry.lpContentFile}: siteId does not match catalog`);
		}
	}
}
